var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import Entrada from './entrada';

var CabeceraIndice = function (_React$Component) {
  _inherits(CabeceraIndice, _React$Component);

  function CabeceraIndice() {
    _classCallCheck(this, CabeceraIndice);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  CabeceraIndice.prototype.renderExtras = function renderExtras() {
    var _props = this.props,
        configIndice = _props.configIndice,
        onEntrada = _props.onEntrada;
    return configIndice.extrasCabecera.map(function (entrada, index) {
      return React.createElement(Entrada, _extends({
        key: 'entrada-extra-cabecera-index-' + index
      }, entrada, {
        onClick: function onClick() {
          return onEntrada(entrada, index);
        }
      }));
    });
  };

  CabeceraIndice.prototype.render = function render() {
    var _props2 = this.props,
        configIndice = _props2.configIndice,
        children = _props2.children;
    var fondoCabecera = configIndice.fondoCabecera,
        nivel = configIndice.nivel,
        titulo = configIndice.titulo,
        subtitulo = configIndice.subtitulo,
        extrasCabecera = configIndice.extrasCabecera,
        logo = configIndice.logo;
    return React.createElement('div', {
      className: 'cabeceraIndice'
    }, fondoCabecera && React.createElement('img', {
      src: fondoCabecera,
      alt: ''
    }), logo !== false && React.createElement('div', {
      className: 'logo'
    }), nivel && React.createElement('div', {
      className: 'nivel'
    }, nivel), titulo && React.createElement('div', {
      className: 'titulo'
    }, titulo), subtitulo && React.createElement('div', {
      className: 'subtitulo'
    }, subtitulo), children, extrasCabecera && this.renderExtras());
  };

  return CabeceraIndice;
}(React.Component);

CabeceraIndice.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string.isRequired,
  configIndice: t.shape({
    fondoCabecera: t.string.isRequired,
    nivel: t.string,
    titulo: t.string
  }).isRequired,
  // onIndice: t.func.isRequired,
  // onAtras: t.func.isRequired,
  onEntrada: t.func.isRequired,
  children: t.any
} : {};
export default CabeceraIndice;